import { COUNTRIES, getDefaultCountryId } from 'config/countries-data'
import { type DeliveryPromiseAddress } from 'services/ShippingOptionsManager'
import { verifyState } from 'utils/AddressUtils'

interface GetIpLocationAddressParams {
  ipCountry: string
  ipState: string
}

// US delivery dates vary by state, so a US location also carries the IP state.
export function getIpLocationAddress({
  ipCountry,
  ipState,
}: GetIpLocationAddressParams): DeliveryPromiseAddress {
  if (ipCountry !== COUNTRIES.UNITED_STATES.code) {
    return { countryId: getDefaultCountryId() }
  }
  if (!verifyState(COUNTRIES.UNITED_STATES.code, ipState)) {
    return { countryId: COUNTRIES.UNITED_STATES.id }
  }
  return { countryId: COUNTRIES.UNITED_STATES.id, state: ipState }
}
